define.alias("shared/helpers/css-safe", "calendar/helpers/css-safe");